import React, { Component } from 'react';
import styled from 'styled-components';
import PageHeader from '../components/PageHeader';
import PDFModal from "../components/PDFModal";
import __ from '../utils/translator';
import ManualStoreActions from "../flux/ManualStoreActions";
import ManualStore from "../flux/ManualStore";
import ConfidentialIcon from '../components/ConfidentialIcon';
import PageTitle from '../components/PageTitle';
import Header from '../components/organisms/Header';
import ThronModal from "../components/ThronModal";

class Manuals extends Component {

  constructor(props){
    super(props);
    this.onMediaClick = this.onMediaClick.bind(this);
    this.onPDFModalCloseButtonClick = this.onPDFModalCloseButtonClick.bind(this);
  }

  state = {
    collections: [],
    pdfModalOpened: false,
    manualAssetClicked: null,
  };

  subscriptions = [];

  onMediaClick(manual) {
    this.setState({
      pdfModalOpened: true,
      manualAssetClicked: manual,
    });
  }

  onPDFModalCloseButtonClick(){
    this.setState({ pdfModalOpened: false, manualAssetClicked: null});
  }

  componentDidMount() {
    ManualStoreActions.getAll();

    this.subscriptions.push(ManualStore.addListener(() => {
      const collections = ManualStore.getState();
      this.setState({collections});
    }));

  };

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    return (
      <div>
        <Header />

        <PageTitle withTracking title="Merchandising manuals" />

        <PageHeader
          smallTitle
          crumbs={[__('Home'), __('Merchandising manuals')]}
          title={__('Merchandising Manuals')} />

        <div style={{ padding: '1rem 3rem' }}>
          {this.state.collections.length === 0 && (
            <span>{__('No Manuals available')}</span>
          )}

          {this.state.collections.length > 0 && (
            <ManualsContainer>
              {this.state.collections.map(collection => (
                <CollectionsContainer key={collection.id}>
                  <div>
                    {collection.confidential && (
                      <ConfidentialIcon style={{ marginRight: '.5rem' }} />
                    )}
                    {collection.name}
                  </div>
                  <ManualsList>
                    {collection.manuals.map(manual => (
                      <ManualItem key={manual.id} onClick={() => this.onMediaClick(manual)}>
                        {manual.name}
                      </ManualItem>
                    ))}
                  </ManualsList>
                </CollectionsContainer>
              ))}
             </ManualsContainer>
          )}
        </div>

        {this.state.pdfModalOpened && (
/*          <PDFModal
            asset={this.state.manualAssetClicked}
            onCloseButtonClick={this.onPDFModalCloseButtonClick}
            onPdfLoad={() => {
              ManualStoreActions.manualLoad(this.state.manualAssetClicked.id, this.state.manualAssetClicked.collectionId);
            }}
          />*/
          <ThronModal asset={this.state.manualAssetClicked} onCloseButtonClick={this.onPDFModalCloseButtonClick}/>
        )}
      </div>
    );
  }
}

export default Manuals;

const ManualsContainer = styled.div`
  padding-left: 1.625rem;
  padding-top: 2.625rem;
  border-left: 2px solid rgb(222, 222, 222);
`;

const CollectionsContainer = styled.div`
  position: relative;

  &:before{
    content: '';
    display: block;
    position: absolute;
    background-color: #CCCCCC;
    left: -2.1025rem;
    top: 0.28rem;
    bottom: 0;
    width: 0.875rem;
    height: 0.875rem;
  }
`;

const ManualsList = styled.div`
  padding: 2rem 0rem 1.2rem 0rem;
`;

const ManualItem = styled.span `
    display: inline-block;
    margin: 0rem 1.375rem 1.375rem 0rem;
    padding: 0.8125rem;
    background-color: #fff;
    color: #565656;
    box-shadow: rgba(0,0,0,.2) 0px 0px 10px 1px;
`
